const generals = {
  none:"Keine",
  saveStockOrder: "Börsenauftrag speichern",
  addStockOrder: "Börsenauftrag hinzufügen",
  addCargo: "Fracht hinzufügen",
  warning: "Warnung",
  free: "Frei",
  no_street: "keine Straße",
  select: "Wählen",
  typeOfAccount: "Art des registrierten Kontos",
  returnToLogin: "Zur Anmeldung zurückkehren",
  haveAccount: "Haben Sie bereits ein Konto?",
  logIn: "Klicken Sie, um sich anzumelden",
  deleteFile: "Datei löschen",
  start: "START",
  finish: "ZIEL",
  auction_add_success: "Auktion erfolgreich hinzugefügt",
  map: "Karte",
  auctionList: "Auktionsliste",
  pilotOffers: "Pilotenangebote",
  techHelp: "Technischer Support",
  documentVerified: "Dieses Dokument wurde bereits verifiziert",
  policyTo: "Police bis",
  vehicleData: "Fahrzeugdaten",
  dataBefore: "Vorherige Daten",
  dataNow: "Aktuelle Daten",
  existingDriver: "Bestehenden Fahrer auswählen",
  manualDriver: "Daten manuell eingeben",
  price: "Pauschalpreis",
  offering: "Anbieter",
  number_of_days_short: "Tage",
  radius: "Radius [km]",
  comment: "Kommentar",
  edit_car: "Fahrzeug bearbeiten",
  mark_all_as_read: "Alle als gelesen markieren",
  optional: "optional",
  timeFrames: "Zeitrahmen",
  main_page: "Startseite",
  all: "Alle",
  invitation_sent: "Einladung gesendet",
  company_invitation: "Firmeneinladung",
  close: "Schließen",
  see: "Ansehen",
  title: "Titel",
  content: "Inhalt",
  unBlock: "Entsperren",
  wallet: "Wallet",
  error: "Fehler",
  return: "Zurück",
  fold: "Einklappen",
  operation: "Vorgang",
  reserve: "Reservieren",
  new: "Neu",
  add_windows: "Zeitfenster hinzufügen",
  reservation_success: "Reservierungsanfrage erfolgreich gesendet",
  delete: "Löschen",
  cmr: "Zum CMR-Dokument",
  from_driver: "Vom Spediteur",
  for_provision: "Für Provision",
  "transporting-doc": "Transportauftragsdokument",
  edit: "Bearbeiten",
  loading: "Laden...",
  authorizations: "Autorisierungen",
  warehouse: "Lagerhaus",
  monitary_notes: "Benachrichtigungen",
  accepted: "Akzeptiert",
  rejected: "Abgelehnt",
  opening: "Öffnung",
  closing: "Schließung",
  save: "Speichern",
  saving: "Speichert...",
  authorize: "Autorisieren",
  reject: "Ablehnen",
  block: "Blockieren",
  see_details: "Ansehen",
  add: "Hinzufügen",
  change_workers: "Mitarbeiter verwalten",
  add_pics: "Fotos hinzufügen",
  add_avatar: "Avatar hinzufügen",
  added_avatar: "Avatar hinzugefügt",
  department: "Abteilung",
  actions: "",
  action: "Aktion",
  workers: "Mitarbeiter",
  fullName: "Vollständiger Name",
  elements_visible: "Zeilen pro Seite",
  notepad: "Notizbuch",
  message: "Nachricht",
  documents: "Dokumente",
  true: "Wahr",
  false: "Falsch",
  yes: "Ja",
  no: "Nein",
  success: "Erfolg",
  successful_edit: "Erfolgreich bearbeitet",
  archive: "Abschließen",
  accept: "Akzeptieren",
  added: "Hinzugefügt",
  step: "Schritt",
  download: "Herunterladen",
  go_further: "Weiter",
  go: "Gehe zu",
  closed: "Geschlossen",
  logout: "Abmelden",
  tutorial: "Tutorial",
  this_document_will_be_public: "Dieses Dokument wird öffentlich sein",
  language: "Sprache",
  agreement: "Vertrag",
  invoices: "Rechnungen",
  cancel: "Abbrechen",
  from: "Von",
  to: "Bis",
  back: "Zurück",
  search: "Suchen",
  retreat: "Zurückziehen",
  phone: "Telefon",
  no_id: "Keine ID",
  no_drivers: "Keine Fahrer",
  ignore: "Ignorieren",
  departments: "Abteilungen",
  verify: "Verifizieren",
  status: "Status",
  chat: "Chat",
  note: "Notiz",
  details: "Details",
  unfold: "Ausklappen",
  departments_count: "Anzahl der Abteilungen",
  warehouse_count: "Anzahl der Lagerhäuser",
  change_number: "Nummer bearbeiten",
  change_number_enter: "Neue Telefonnummer eingeben",
  refresh: "Aktualisieren",
  home: "Details",
  offer: "Angebot abgeben",
  my_offers: "Meine Angebote",
  contact: "Kontakt",
  data: "Auktion",
  auto: "Automatisches Bieten",
  diary: "Transaktionsprotokoll",
  changelog: "Änderungsprotokoll",
  stock_chat: "Nachricht senden",
  fullscreen: "Größe ändern",
  for_day: "pro Tag",
  out_of: "von",
  next: "Weiter",
  leave: "Verlassen",
  confirm: "Bestätigen",
  auction_nr: "Auktion Nr.",
  monitory_nr: "Benachrichtigung Nr.",
  mine: "Meine",
  generally: "Allgemein",
  reservation: "Reservierung",
  returning: "Rückgabe",
  no_cars: "Keine Autos",
  left: "Verbleibend",
  minutes: "Min.",
  group_message: "Gruppennachricht",
  to_group: "An Benutzergruppen",
  to_specific: "An bestimmte Abteilungen",
  chosen_departments: "Ausgewählte Abteilungen",
  docs: "Firmendokumente",
  data_refreshed: "Daten aktualisiert",
  mark_read: "Markieren",
  no_data: "Keine Daten",
  creation_date: "Erstellungsdatum",
  preview: "Vorschau",
  change: "Ändern",
  danger: "Achtung",
  copy_to_clipboard: "Kopieren",
  copy_to_clipboard_success: "In Zwischenablage kopiert",
  copy_to_clipboard_error: "Kopieren in Zwischenablage fehlgeschlagen",
  open_chat: "Chat öffnen",
  confirm_action: "Bestätigen",
  date_expired: "Abgelaufen",
  days_helper: "{0} Tage",
  load: "Ladung",
  mark_unread: "Als ungelesen markieren",
  too_long_title: "Titel zu lang",
  month: "Monat",
  year: "Jahr",
  unavailable: "Nicht verfügbar",
  lack: "Fehlt",
  downloadTimeout: "Sie müssen einige Sekunden warten, bevor Sie Dateien erneut herunterladen können.",
  pick: "Wählen",
  downloadableDocuments: "Herunterladbare Dokumente",
  ofWarehouses: "Lagerhäuser",
  ofDepartments: "Abteilungen",
  pay: "Bezahlen",
  setProvision: "Provision für die Anzeige festlegen",
  verificationConfirmation: "Sind Sie sicher, dass Sie das Unternehmen manuell verifizieren möchten?",
  rating: "Bewertung",
  send: "Senden",
  countWorkers: "Anzahl der Mitarbeiter",
  verificationPendingTitle: "Autorisierung läuft.",
  verificationDemandTitle: "Autorisierung erforderlich!",
  verificationPendingDesc: "Autorisierung wird bearbeitet.",
  verificationDemandDesc: "Um die volle Funktionalität der Plattform XLplanner.eu freizuschalten, autorisieren Sie bitte Ihr Unternehmen.",
  authorizePayment: "Zahlung autorisieren",
};
export default generals;
